import { useState, useCallback } from 'react';

export const QUOTE_REQUIRED_FIELDS = ['accountExecutive', 'preparedFor', 'salesforceQuoteNumber', 'opportunityID'];

const EMPTY_ERRORS = { accountExecutive: '', opportunityID: '', preparedFor: '', salesforceQuoteNumber: '' };

/** Verbatim from App.js:1221–1232 (CONF-140 Phase 0b). Returns '' when valid. */
export function validateQuoteField(field, value) {
  if (field === 'accountExecutive') return !value ? 'Account Executive is required.' : '';
  if (field === 'preparedFor') return !value?.trim() ? 'Customer Name is required.' : '';
  if (field === 'salesforceQuoteNumber') return !/^\d{5}$/.test(value?.trim()) ? 'Must be exactly 5 digits.' : '';
  if (field === 'opportunityID') {
    return (!value || value.length !== 18 || !/^[A-Za-z0-9]+$/.test(value)) ? 'Must be 18 alphanumeric characters.' : '';
  }
  return '';
}

/** One message per required field, '' where valid. Used by the quote gate and (later) the readiness meter. */
export function validateAllQuoteFields(metadata) {
  return Object.fromEntries(QUOTE_REQUIRED_FIELDS.map((f) => [f, validateQuoteField(f, metadata?.[f])]));
}

export function useQuoteValidation() {
  const [quoteErrors, setQuoteErrors] = useState(EMPTY_ERRORS);
  const setFieldError = useCallback((field, value) => {
    setQuoteErrors((prev) => ({ ...prev, [field]: validateQuoteField(field, value) }));
  }, []);
  // Not called from production code yet — no classic call site clears the whole
  // error set at once — so this hook's own tests are its only callers today.
  // Deliberate V2 groundwork; leave it in place.
  const clearQuoteErrors = useCallback(() => setQuoteErrors(EMPTY_ERRORS), []);
  return { quoteErrors, setQuoteErrors, setFieldError, clearQuoteErrors };
}

export default useQuoteValidation;
